module.exports = __webpack_public_path__ + "assets/img/home_ex_2.d161d3c3.png";